







































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunitiesListModule } from '@/store/modules/opportunitiesList';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunityStatus from '@/models/Opportunities/OpportunityStatus';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'OpportunityListSearchCriteria' })
export default class extends GiganautVueDialog {
  public dialog = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val) {
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
      if (AgencySettingsModule.agencyUsers.length === 0) {
        await AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.locationTypes.length === 0) {
        await AgencySettingsModule.getLocationTypes();
      }
    }
  }

  get filter() {
    return OpportunitiesListModule.filter;
  }

  get hasActiveFilters(): boolean {
    return OpportunitiesListModule.hasActiveFilters;
  }

  get loading(): boolean {
    return OpportunitiesListModule.loading;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get desks() {
    if (!this.filter.branchId) return [];
    const branch = AgencySettingsModule.branches.find((b: any) => b.id === this.filter.branchId);
    return branch ? branch.desks : [];
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  get statusOptions() {
    return [
      { name: 'Open', value: OpportunityStatus.Open },
      { name: 'Closed', value: OpportunityStatus.Closed },
    ];
  }

  ownerLabel(item: any) {
    return item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  onBranchChanged() {
    // Desk belongs to a branch — drop the selection when the branch changes.
    this.filter.deskId = null;
  }

  async search() {
    this.dialog = false;
    await OpportunitiesListModule.search();
  }

  async clear() {
    this.dialog = false;
    await OpportunitiesListModule.clearFilter();
  }
}
